import type { ComponentType } from 'react';

import type createTestIds from './createTestIds';

const withTestIds = <C extends ComponentType<any>, F extends ReturnType<typeof createTestIds>>(
  Comp: C,
  getTestIds: F
): C & { getTestIds: F } => {
  (Comp as C & { getTestIds: F }).getTestIds = getTestIds;
  return Comp as C & { getTestIds: F };
};

export default withTestIds;
